import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ActionType } from "./actions.js";
import { addIndexAction, changeIndexNameAction, changeIndexUniqueAction, removeIndexAction } from "./atom.actions.js";
//#region src/engine/modules/index/history.ts
var addIndex = (undoActions, { payload: { id } }) => {
	undoActions.push(removeIndexAction({ id }));
};
var removeIndex = (undoActions, { payload: { id } }, { collections }) => {
	const index = query(collections).collection("indexEntities").selectById(id);
	if (!index) return;
	undoActions.push(addIndexAction({
		id,
		tableId: index.tableId
	}));
};
var changeIndexName = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const index = query(collections).collection("indexEntities").selectById(id);
	if (!index) return;
	undoActions.push(changeIndexNameAction({
		id,
		tableId,
		value: index.name
	}));
};
var changeIndexUnique = (undoActions, { payload: { id, tableId, value } }, { collections }) => {
	if (!query(collections).collection("indexEntities").selectById(id)) return;
	undoActions.push(changeIndexUniqueAction({
		id,
		tableId,
		value: !value
	}));
};
var indexPushUndoHistoryMap = {
	[ActionType.addIndex]: addIndex,
	[ActionType.removeIndex]: removeIndex,
	[ActionType.changeIndexName]: changeIndexName,
	[ActionType.changeIndexUnique]: changeIndexUnique
};
//#endregion
export { indexPushUndoHistoryMap };
